<template>
  <div>
    <h1>Carrier:&nbsp;&nbsp;<strong>{{ value.carrier.name }}</strong></h1>
    <el-alert
      v-if="value.carrier.configuration_notes"
      type="warning"
      show-icon
      title="Configuration Notes"
      :description="value.carrier.configuration_notes"
      :closable="false"
    />
    <el-form
      ref="carrierSettingForm"
      v-loading="isSaving"
      :rules="rules"
      :model="value"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Charge Account"
            prop="charge_account"
          >
            <el-input
              v-model="value.charge_account"
              placeholder="Charge Account"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Quote Externally"
            prop="quote_externally"
          >
            <el-select
              v-model="value.quote_externally"
              placeholder="Quote Externally"
              class="w-100"
              default-first-option
              :disabled="!value.carrier_is_customers"
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="6">
          <el-form-item
            label="Active In Shipper"
            prop="active_in_shipper"
          >
            <el-select
              v-model="value.active_in_shipper"
              placeholder="Active In Shipper"
              class="w-100"
              default-first-option
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Carrier Active"
            prop="carrier_active"
          >
            <el-select
              v-model="value.carrier_active"
              placeholder="Carrier Active"
              class="w-100"
              default-first-option
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Carrier Is Customers"
            prop="carrier_is_customers"
          >
            <el-select
              v-model="value.carrier_is_customers"
              placeholder="Carrier Is Customers"
              class="w-100"
              default-first-option
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Always Third Party"
            prop="always_third_party"
          >
            <el-select
              v-model="value.always_third_party"
              placeholder="Always Third Party"
              class="w-100"
              default-first-option
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Consignment</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Prefix"
            prop="con_prefix"
          >
            <el-input
              v-model="value.con_prefix"
              :placeholder="value.carrier.config_con_prefix_def ? value.carrier.config_con_prefix_def : 'Consignment Prefix'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Next ID"
            prop="con_next_id"
          >
            <el-input
              v-model="value.con_next_id"
              placeholder="Consignment Next ID"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Min"
            prop="con_min"
          >
            <el-input
              v-model="value.con_min"
              :placeholder="value.carrier.config_con_min_def ? value.carrier.config_con_min_def : 'Consignment Min'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Max"
            prop="con_max"
          >
            <el-input
              v-model="value.con_max"
              :placeholder="value.carrier.config_con_max_def ? value.carrier.config_con_max_def : 'Consignment Max'"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Manifest</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Prefix"
            prop="manifest_prefix"
          >
            <el-input
              v-model="value.manifest_prefix"
              :placeholder="value.carrier.config_man_prefix_req ? value.carrier.config_man_prefix_def : 'Manifest Prefix'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Next ID"
            prop="manifest_nextid"
          >
            <el-input
              v-model="value.manifest_nextid"
              placeholder="Manifest Next ID"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Min"
            prop="manifest_min"
          >
            <el-input
              v-model="value.manifest_min"
              :placeholder="value.carrier.config_man_min_def ? value.carrier.config_man_min_def : 'Manifest Min'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Max"
            prop="manifest_max"
          >
            <el-input
              v-model="value.manifest_max"
              :placeholder="value.carrier.config_man_max_def ? value.carrier.config_man_max_def : 'Manifest Max'"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>EDI</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Site ID"
            prop="edi_siteid"
          >
            <el-input
              v-model="value.edi_siteid"
              placeholder="Site ID"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Sys ID"
            prop="edi_sysid"
          >
            <el-input
              v-model="value.edi_sysid"
              placeholder="Sys ID"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      rules: {
        charge_account: [
          { required: true, message: 'Charge Account is required', trigger: ['blur', 'change'] }
        ],
        active_in_shipper: [
          { required: true, message: 'Active In Shipper is required', trigger: ['blur', 'change'] }
        ],
        carrier_active: [
          { required: true, message: 'Carrier Active is required', trigger: ['blur', 'change'] }
        ],
        carrier_is_customers: [
          { required: true, message: 'Carrier Is Customer is required', trigger: ['blur', 'change'] }
        ],
        always_third_party: [
          { required: true, message: 'Always Third Party is required', trigger: ['blur', 'change'] }
        ],
        con_prefix: [
          { required: this.value.carrier.config_con_prefix_req, message: 'Consignment Next ID is required', trigger: ['blur', 'change'] }
        ],
        con_next_id: [
          { required: true, message: 'Consignment Next ID is required', trigger: ['blur', 'change'] }
        ],
        con_min: [
          { required: true, message: 'Consignment Min is required', trigger: ['blur', 'change'] }
        ],
        con_max: [
          { required: true, message: 'Consignment Max is required', trigger: ['blur', 'change'] }
        ],
        manifest_prefix: [
          { required: this.value.carrier.config_man_prefix_req, message: 'Manifest Next ID is required', trigger: ['blur', 'change'] }
        ],
        manifest_nextid: [
          { required: true, message: 'Manifest Next ID is required', trigger: ['blur', 'change'] }
        ],
        manifest_min: [
          { required: true, message: 'Manifest Min is required', trigger: ['blur', 'change'] }
        ],
        manifest_max: [
          { required: true, message: 'Manifest Max is required', trigger: ['blur', 'change'] }
        ],
        edi_siteid: [
          { required: this.value.carrier.edi_siteid_req, message: 'EDI Site ID is required', trigger: ['blur', 'change'] }
        ],
        edi_sysid: [
          { required: this.value.carrier.edi_sysid_req, message: 'EDI Sys ID is required', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    value () {
      // Refresh carrier specific rules
      this.rules.con_prefix = [{ required: this.value.carrier.config_con_prefix_req, message: 'Consignment Next ID is required', trigger: ['blur', 'change'] }]
      this.rules.manifest_prefix = [{ required: this.value.carrier.config_man_prefix_req, message: 'Manifest Next ID is required', trigger: ['blur', 'change'] }]
      this.rules.edi_siteid = [{ required: this.value.carrier.edi_siteid_req, message: 'EDI Site ID is required', trigger: ['blur', 'change'] }]
      this.rules.edi_sysid = [{ required: this.value.carrier.edi_sysid_req, message: 'EDI Sys ID is required', trigger: ['blur', 'change'] }]
    },
    'value.carrier_is_customers' () {
      // Disable quote_externally if carrier_is_customers is false
      if (!this.value.carrier_is_customers) {
        this.value.quote_externally = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
